export const PathDefinition = {
    home: '/',
    account: '/account',
    signIn: '/signIn',
    forgotPassword: '/forgotPassword',
    listDirectOrder: '/listDirectOrder',
    importDirectOrderCheckpoint: '/importDirectOrderCheckpoint',
    importUpdateLastMileReference: '/importUpdateLastMileReference'
};
